var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.793 19.2928L15.4498 14.9497M15.4498 14.9497C16.8975 13.502 17.793 11.502 17.793 9.29285C17.793 4.87457 14.2112 1.29285 9.79297 1.29285C5.37469 1.29285 1.79297 4.87457 1.79297 9.29285C1.79297 13.7111 5.37469 17.2928 9.79297 17.2928C12.0021 17.2928 14.0021 16.3974 15.4498 14.9497Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square"}));
}

Search.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = Search;

Search.default = Search;
